import React, { useState } from "react";
import User from "../../../images/dummy-user.png";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";
import Delete from "./Delete";
import Edit from "./Edit";
import ImgsViewer from "react-images-viewer";

const Card = (props) => {
  const [edit, setEdit] = useState(null);
  const [showImage, setShowImage] = useState(false);
  const [deleteTestimonial, setDelete] = useState(null);

  return (
    <>
      <div className="card">
        <div className="card-body">
          {props.data?.image && (
            <>
              {showImage && (
                <ImgsViewer
                  backdropCloseable
                  imgs={[
                    {
                      src: props.data?.image,
                    },
                  ]}
                  isOpen={showImage}
                  onClose={() => setShowImage(false)}
                />
              )}
            </>
          )}
          <div className="user-content">
            <p className="small text-muted mb-0 pl0 line-break-4">
              {props.data?.image ? (
                <a onClick={() => setShowImage(true)} href="javascript:void(0)">
                  {props.data?.content}
                </a>
              ) : (
                <>{props.data?.content}</>
              )}
            </p>
          </div>
        </div>
        <div className="testimonial-img-main">
          <div className="testimonial-img">
            <div className="user-picture">
              <img
                src={User}
                alt={User}
                className=" shadow-sm rounded-circle"
              />
            </div>
            <Link
              to={`/athletes/${props.data?.playerCustomURL}`}
              target="_blank"
            >
              <h5 className="text-capitalize user-name">
                {props.data?.playerName}
              </h5>
            </Link>
          </div>
          <div className="testimonial-btns">
            {props.data?.image && (
              <Button
                circular
                icon="eye"
                color="green"
                onClick={() => setShowImage(true)}
              />
            )}

            {props.edit && props.data && (
              <>
                <Button
                  circular
                  icon="edit"
                  color="blue"
                  onClick={() => setEdit(props.data)}
                />
                <Button
                  circular
                  icon="trash"
                  color="red"
                  onClick={() => setDelete(props.data)}
                />
              </>
            )}
          </div>
        </div>
      </div>
      {deleteTestimonial && (
        <Delete
          deleteId={deleteTestimonial}
          close={() => {
            setDelete(null);
          }}
        />
      )}
      {edit && (
        <Edit
          open={edit}
          close={() => {
            setEdit(null);
          }}
        />
      )}
    </>
  );
};

export default Card;
